import axios from 'axios'
import 'react-loading-skeleton/dist/skeleton.css'
import { classNames } from '../components/common/Helpers'
import SubscribeForm from './SubscribeForm'
import { globalStore } from './store/root'

export default function App({ data }) {

    const token = data.getAttribute('data-token')
    const type = data.getAttribute('data-type') || 'obituary'
    const mode = data.getAttribute('data-mode') || 'light'

    axios.interceptors.request.use(
        (config) => {
            config.headers['Authorization'] = `Bearer ${token}`
            return config
        },
    )
    if (data.getAttribute('data-organization-id')) {
        axios.defaults.headers.common['X-Organization-Id'] = data.getAttribute('data-organization-id')
    }

    return (
        <div className={classNames("p-8", mode == "dark" ? "text-white" : "")}>
            {type == 'daily-grief' || type == 'grief-step'
                ?
                <SubscribeForm
                    type={type}
                    title={<img src={mode == "dark"
                        ? "/images/vendors/griefsteps-logo-white.png"
                        : "/images/vendors/griefsteps-logo.png"
                    } className="px-10" />}
                    subtitle="A Year of Grief Support"
                    description="Sign up for one year of weekly grief messages designed to provide strength and comfort during the challenging first year after your loss"
                    store="subscribeDailyGrief"
                    service={globalStore.subscribeDailyGrief.services}
                />
                :
                <SubscribeForm
                    type={type}
                    title="Subscribe"
                    description="Subscribe to get alerts on new obituaries"
                    store="subscribeObituary"
                    service={globalStore.subscribeObituary.services}
                />
            }
        </div>
    )
}